import router from './router'

export default router


// WEBPACK FOOTER //
// ./src/router/index.js